import { CheckInStatus } from "../../molecules/CheckIn/CheckInStatus";

interface CheckInTemplateProps {
  status: string;
}

export const CheckInTemplate = ({ status }: CheckInTemplateProps) => {
  return <CheckInStatus status={status} />;
};
